import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LeadFinance,LeadFinanceData } from '../data/leadFinance';
import { MessageHandlerService } from "../../services/message-handler.service"
import { EventEmitter } from '@angular/core';

@Injectable()
export class LeadFinanceService extends LeadFinanceData {

  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiChat: string;
  header: any;
  constructor(private http: HttpClient, private messageHandler: MessageHandlerService) {
    super();
    this.api = environment.apiUrl;
  }


  async getLeadsFinance(pagination, filter, order) {
    console.log({ pagination, filter, order });
    try {
      let response = await this.http.post(this.api + "finance/leads", { pagination, filter, order }).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)
    }
  }

  async getLeadFinance(id: string) {
    try {

      let lead = <LeadFinance>await this.http.get(this.api + "finance/lead/" + id).toPromise();
      return lead

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  

  async sendLeadFinance( id) {
    try {

      let response = <LeadFinance>await this.http.put(this.api + "finance/leads/" + (id || ''), {}).toPromise();
      return response
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message)
    }
  }

}

